export enum InboxTypeEnum {
  MENTIONS = 'MENTIONS',
  BULK_MENTIONS = 'BULK_MENTIONS',
  NOTES = 'NOTES',
  BULK_NOTES = 'BULK_NOTES',
  INTERVIEWS = 'INTERVIEWS',
  INTERVIEW_SCORES = 'SCORES',
  CANDIDATE_OWNER_ASSIGNED = 'CANDIDATE_OWNER_ASSIGNED',
  BULK_CANDIDATE_OWNER_ASSIGNED_REMOVED = 'BULK_CANDIDATE_OWNER_ASSIGNED_REMOVED',
  JOB_OWNER_COLLABORATOR_ASSIGNED_REMOVED = 'JOB_OWNER_COLLABORATOR_ASSIGNED_REMOVED',
  CANDIDATE_UNDER_REVIEW = 'CANDIDATE_UNDER_REVIEW',
  STAGE_CHANGED = 'STAGE_CHANGED',
  CANDIDATE_ARCHIVED = 'CANDIDATE_ARCHIVED',
  CANDIDATE_UNARCHIVED = 'CANDIDATE_UNARCHIVED',
  EMAIL_SENT = 'EMAIL_SENT',
  REPLY_FROM_CANDIDATE = 'REPLY_FROM_CANDIDATE',
  OFFER_SENT = 'OFFER_SENT',
  OFFER_ACCEPTED = 'OFFER_ACCEPTED',
  OFFER_REJECTED = 'OFFER_REJECTED',
  APPROVAL_REQUEST = 'APPROVAL_REQUEST',
  REQUISITION_APPROVED = 'REQUISITION_APPROVED',
  REQUISITION_REJECTED = 'REQUISITION_REJECTED',
  REQUISITION_RECRUITER_ASSIGNED = 'REQUISITION_RECRUITER_ASSIGNED',
  REQUISITION_RECRUITER_REMOVED = 'REQUISITION_RECRUITER_REMOVED',
  MENTIONS_REPLY = 'MENTIONS_REPLY',
}
export enum InboxActionsEnum {
  MARK_ALL_READ = 'MARK_ALL_READ',
  MARL_ALL_UNREAD = 'MARL_ALL_UNREAD',
  DELETE_ALL_NOTIFICATIONS = 'DELETE_ALL_NOTIFICATIONS',
  DELETE_ALL_READ_NOTIFICATIONS = 'DELETE_ALL_READ_NOTIFICATIONS'
}

export enum InboxFilterEnum {
  ALL = 'ALL',
  UNREAD = 'UNREAD',
  STARRED = 'STARRED'
}

export enum NotificationIconType {
  WC_ICON_USER = 'WcIconUser',
  WC_ICON_SUITCASE = 'WcIconSuitcase',
  WC_ICON_NOTES = 'WcIconNotes',
  WC_ICON_EMAIL = 'WcIconEmail',
  WC_ICON_OFFER = 'WcIconOffer',
  WC_ICON_PENCIL = 'WcIconPencil',
  WC_ICON_CALENDAR_CIRCLE = 'WcIconCalendarCircle',
  WC_ICON_ADD_NOTE = 'WcIconAddNote'
}
export interface IconConfig {
  component: string
  props?: Record<string, any>
}
export const getIconConfig: Record<NotificationIconType, IconConfig> = {
  [NotificationIconType.WC_ICON_USER]: {
    component: NotificationIconType.WC_ICON_USER,
    props: { height: 14, width: 14 }
  },
  [NotificationIconType.WC_ICON_NOTES]: {
    component: NotificationIconType.WC_ICON_NOTES,
    props: { height: 14, width: 14 }
  },
  [NotificationIconType.WC_ICON_EMAIL]: {
    component: NotificationIconType.WC_ICON_EMAIL,
    props: { height: 14, width: 14 }
  },
  [NotificationIconType.WC_ICON_OFFER]: {
    component: NotificationIconType.WC_ICON_OFFER,
    props: { height: 14, width: 14 }
  },
  [NotificationIconType.WC_ICON_SUITCASE]: {
    component: NotificationIconType.WC_ICON_SUITCASE,
    props: { height: 14, width: 14 }
  },
  [NotificationIconType.WC_ICON_ADD_NOTE]: {
    component: NotificationIconType.WC_ICON_ADD_NOTE,
    props: { height: 14, width: 14 }
  },
  [NotificationIconType.WC_ICON_PENCIL]: {
    component: NotificationIconType.WC_ICON_PENCIL,
    props: { size: 'xs' }
  },
  [NotificationIconType.WC_ICON_CALENDAR_CIRCLE]: {
    component: NotificationIconType.WC_ICON_CALENDAR_CIRCLE,
    props: { class: 'w-[12px] h-[12px]' }
  }
}
